import { render, staticRenderFns } from "./ButtonShareComponent.vue?vue&type=template&id=0fda5242"
import script from "./ButtonShareComponent.vue?vue&type=script&lang=js"
export * from "./ButtonShareComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports